/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs'

const $nsid = 'app.bsky.feed.getFeedGenerators'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  feeds: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  feeds: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.GeneratorView>(
      (() => FeedDefs.generatorView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get information about a list of feed generators. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
